import React, { Component } from 'react';
import { Menu } from 'antd';
const SubMenu = Menu.SubMenu;

class Sider extends Component {
    constructor(props) {
        super(props);
        const { selectKey } = props;
        this.state = {
            current: selectKey,
        };
    }

    handleClick = e => {
        this.setState({
            current: e.key,
        });
    }

    render() {
        const { curRole, invState } = sessionStorage;
        const isPM = curRole == 'PM';
        const isBO = curRole == 'BO';
        const isCTA = curRole == 'CTA';
        const isCRCM = curRole == 'CRCM';
        const isCRCC = curRole == 'CRCC';
        const isVP = curRole == 'VP';
        const isFIN = curRole == 'FIN';
        const isPML = curRole == 'PML';
        const isTotal = invState == 1;
        return (
            <aside className="sidebar">
                <Menu
                    onClick={this.handleClick}
                    defaultOpenKeys={['sub1']}
                    selectedKeys={[this.state.current]}
                    mode="inline"
                >
                    <SubMenu key="sub1" title={<span><i className="icon iconfont">&#xe6a7;</i><span>项目汇总</span></span>}>
                        <Menu.Item key="weeklySummary">
                                <a href="#/sumTotal/weeklySummary">{isTotal ? '项目' : '中心'}周汇总</a>
                            </Menu.Item>
                        <Menu.Item key="monthlySummary">
                            <a href="#/sumTotal/monthlySummary">{isTotal ? '项目' : '中心'}月汇总</a>
                        </Menu.Item>
                        <Menu.Item key="efficiency">
                            <a href="#/sumTotal/efficiency">{isTotal ? '项目' : '中心'}效率</a>
                        </Menu.Item>
                      	{
                            isTotal && !isCTA &&
                            <Menu.Item key="percent">
                                <a href="#/sumTotal/percent">项目完工百分比</a>
                            </Menu.Item>
                        }
                        {
                            <Menu.Item key="crcWeekly">
                                <a href="#/sumTotal/crcWeekly">CRC周报</a>
                            </Menu.Item>
                        }
                        {
                            (isCTA || isPM || isBO || isVP || isFIN || isPML || isCRCM || isCRCC) && isTotal &&
                            <Menu.Item key="crcQuarterScore">
                                <a href="#/sumTotal/crcQuarterScore">CRC季度评分</a>
                            </Menu.Item>
                        }
                    </SubMenu>
                </Menu>
            </aside>
        );
    }
}

export default Sider;



// WEBPACK FOOTER //
// ./src/components/sumTotal/SumEffSider.js